/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { DestinationEvacuationDto } from '../models/destination-evacuation-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des destinations d'évacuation
 */
@Injectable({
  providedIn: 'root',
})
export class DestinationEvacuationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation destinationEvacuationGetList
   */
  static readonly DestinationEvacuationGetListPath = '/api/destination-evacuation/list';

  /**
   * Renvoie la liste des destinations d'évacuation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `destinationEvacuationGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  destinationEvacuationGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<DestinationEvacuationDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DestinationEvacuationService.DestinationEvacuationGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DestinationEvacuationDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des destinations d'évacuation.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `destinationEvacuationGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  destinationEvacuationGetList(params?: {
  }): Observable<Array<DestinationEvacuationDto>> {

    return this.destinationEvacuationGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DestinationEvacuationDto>>) => r.body as Array<DestinationEvacuationDto>)
    );
  }

  /**
   * Path part for operation destinationEvacuationLoadList
   */
  static readonly DestinationEvacuationLoadListPath = '/api/destination-evacuation/load-list';

  /**
   * Renvoie la liste des destinations d'évacuation (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `destinationEvacuationLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  destinationEvacuationLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, DestinationEvacuationService.DestinationEvacuationLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des destinations d'évacuation (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `destinationEvacuationLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  destinationEvacuationLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.destinationEvacuationLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation destinationEvacuationGet
   */
  static readonly DestinationEvacuationGetPath = '/api/destination-evacuation/{id}';

  /**
   * Renvoie la destination d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `destinationEvacuationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  destinationEvacuationGet$Response(params: {

    /**
     * Identifiant de la destination d&#x27;évacuation
     */
    id: number;
  }): Observable<StrictHttpResponse<DestinationEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, DestinationEvacuationService.DestinationEvacuationGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DestinationEvacuationDto>;
      })
    );
  }

  /**
   * Renvoie la destination d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `destinationEvacuationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  destinationEvacuationGet(params: {

    /**
     * Identifiant de la destination d&#x27;évacuation
     */
    id: number;
  }): Observable<DestinationEvacuationDto> {

    return this.destinationEvacuationGet$Response(params).pipe(
      map((r: StrictHttpResponse<DestinationEvacuationDto>) => r.body as DestinationEvacuationDto)
    );
  }

  /**
   * Path part for operation destinationEvacuationGetDestinationConfiguree
   */
  static readonly DestinationEvacuationGetDestinationConfigureePath = '/api/destination-evacuation/{parcId}/{typeId}';

  /**
   * Renvoie la destination d'évacuation pour un recyparc et un type d'évacuation donné.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `destinationEvacuationGetDestinationConfiguree()` instead.
   *
   * This method doesn't expect any request body.
   */
  destinationEvacuationGetDestinationConfiguree$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Identifiant du type d&#x27;évacuation
     */
    typeId: number;
  }): Observable<StrictHttpResponse<DestinationEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, DestinationEvacuationService.DestinationEvacuationGetDestinationConfigureePath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.path('typeId', params.typeId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DestinationEvacuationDto>;
      })
    );
  }

  /**
   * Renvoie la destination d'évacuation pour un recyparc et un type d'évacuation donné.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `destinationEvacuationGetDestinationConfiguree$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  destinationEvacuationGetDestinationConfiguree(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Identifiant du type d&#x27;évacuation
     */
    typeId: number;
  }): Observable<DestinationEvacuationDto> {

    return this.destinationEvacuationGetDestinationConfiguree$Response(params).pipe(
      map((r: StrictHttpResponse<DestinationEvacuationDto>) => r.body as DestinationEvacuationDto)
    );
  }

  /**
   * Path part for operation destinationEvacuationPost
   */
  static readonly DestinationEvacuationPostPath = '/api/destination-evacuation';

  /**
   * Crée la destination d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `destinationEvacuationPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  destinationEvacuationPost$Response(params: {

    /**
     * Destination d'évacuation
     */
    body: DestinationEvacuationDto
  }): Observable<StrictHttpResponse<DestinationEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, DestinationEvacuationService.DestinationEvacuationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DestinationEvacuationDto>;
      })
    );
  }

  /**
   * Crée la destination d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `destinationEvacuationPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  destinationEvacuationPost(params: {

    /**
     * Destination d'évacuation
     */
    body: DestinationEvacuationDto
  }): Observable<DestinationEvacuationDto> {

    return this.destinationEvacuationPost$Response(params).pipe(
      map((r: StrictHttpResponse<DestinationEvacuationDto>) => r.body as DestinationEvacuationDto)
    );
  }

}
